(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  }

  function initToc() {
    const prose = document.querySelector('.aiello-prose');
    const tocEl = document.getElementById('aiello-toc');
    const tocList = document.getElementById('aiello-toc-list');
    if (!prose || !tocEl || !tocList) return;

    const headings = prose.querySelectorAll('h2');
    if (headings.length < 2) return;

    headings.forEach(function (h, i) {
      if (!h.id) h.id = slugify(h.textContent) || 'secao-' + (i + 1);
      var li = document.createElement('li');
      li.className = 'aiello-toc__item';
      var num = String(i + 1).padStart(2, '0');
      li.innerHTML =
        '<a href="#' + h.id + '">' +
          '<span class="aiello-toc__num">' + num + '</span>' +
          h.textContent +
        '</a>';
      tocList.appendChild(li);
    });

    tocEl.style.display = '';

    // Active heading on scroll
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var link = tocList.querySelector('a[href="#' + entry.target.id + '"]');
        if (!link) return;
        if (entry.isIntersecting) {
          tocList.querySelectorAll('a').forEach(function (a) { a.style.color = ''; });
          link.style.color = 'var(--aiello-gold-dark)';
        }
      });
    }, { rootMargin: '-80px 0px -60% 0px' });

    headings.forEach(function (h) { observer.observe(h); });
  }

  function initShare() {
    var copyBtn = document.querySelector('[data-share-copy]');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', function () {
      var url = copyBtn.dataset.shareCopy;
      if (!url) return;
      navigator.clipboard.writeText(url).then(function () {
        copyBtn.classList.add('aiello-share__btn--copied');
        setTimeout(function () { copyBtn.classList.remove('aiello-share__btn--copied'); }, 2000);
      }).catch(function () {
        var input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        copyBtn.classList.add('aiello-share__btn--copied');
        setTimeout(function () { copyBtn.classList.remove('aiello-share__btn--copied'); }, 2000);
      });
    });
  }

  function init() {
    initToc();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
